<!-- reset-password.component.html -->
<div class="" style="width: 100%; display: flex; height: 100vh">
  <!-- Left section - Desktop only -->
  <div class="left-section">
    <div class="left-content">
      <div class="left-text">
        <div class="logo-container">
          <img
            src="/assets/images/logo/MealCheckWhite.webp"
            alt="Logo MealCheck"
            class="logo"
          />
        </div>
        <p class="slogan">Un effectif bien saisi, un service bien servi.</p>
      </div>
    </div>
    <img
      src="/assets/images/representations/two_persons.png"
      alt="Illustration de deux personnes"
      class="left-illustration"
    />
  </div>

  <!-- Right section - Form -->
  <div class="right-section">
    <div class="form-container">
      <!-- Mobile logo -->
      <div class="mobile-logo">
        <img
          src="/assets/images/logo/MealCheckBlack.webp"
          alt="Logo MealCheck"
          class="logo"
        />
      </div>

      <!-- Form header -->
      <div class="form-header">
        <h1>Réinitialisation du mot de passe</h1>
        <div class="info-box">
          <p>Choisissez un nouveau mot de passe sécurisé pour votre compte.</p>
        </div>
      </div>

      <!-- Bloc d'alerte d'erreur -->
      @if (tokenInvalid) {
        <div role="alert" class="alert-danger">
          <div class="alert-content">
            <div class="alert-icon">
              <span class="material-icons">link_off</span>
            </div>

            <div class="alert-text">
              <h3 class="alert-title">Lien de réinitialisation invalide</h3>
              <p class="alert-message">
                Ce lien de réinitialisation a expiré ou n'est plus valide.
                Veuillez demander un nouveau lien pour réinitialiser votre mot
                de passe.
              </p>
            </div>
          </div>

          <div class="alert-actions">
            <button
              type="button"
              (click)="requestNewResetLink()"
              class="btn-primary"
            >
              <span class="material-icons">refresh</span>
              <span>Demander un nouveau lien</span>
            </button>
          </div>
        </div>
      }

      @if (passwordReset) {
        <!-- Success message -->
        <div class="form-group" style="text-align: center; padding: 2rem 0">
          <div style="color: #10b981; font-size: 3rem; margin-bottom: 1rem">
            <span class="material-icons" style="font-size: inherit"
              >check_circle</span
            >
          </div>
          <p style="color: #10b981; font-weight: 500; margin-bottom: 1rem">
            Mot de passe réinitialisé !
          </p>
          <p style="color: #6b7280; margin-bottom: 2rem">
            Votre mot de passe a été modifié avec succès. Vous allez être
            redirigé vers la page de connexion...
          </p>
        </div>
      } @else {
        <!-- Form -->
        <form
          class="form-container"
          [formGroup]="resetForm"
          (ngSubmit)="onSubmit()"
        >
          <!-- Password field -->
          <div class="form-group">
            <label for="password">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                style="
                  width: 16px;
                  height: 16px;
                  display: inline-block;
                  margin-right: 6px;
                  vertical-align: middle;
                "
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
                ></path>
              </svg>
              Nouveau mot de passe
            </label>
            <div class="input-container">
              <input
                [type]="showPassword ? 'text' : 'password'"
                id="password"
                formControlName="password"
                autocomplete="new-password"
                required
                placeholder="••••••••"
                class="text-black w-full !px-4 !py-3 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed"
              />
              <button
                type="button"
                (click)="togglePasswordVisibility()"
                [attr.aria-label]="
                  showPassword
                    ? 'Masquer le mot de passe'
                    : 'Afficher le mot de passe'
                "
                style="
                  position: absolute;
                  right: 12px;
                  top: 50%;
                  transform: translateY(-50%);
                  background: none;
                  border: none;
                  cursor: pointer;
                  color: #6b7280;
                  padding: 4px;
                  display: flex;
                  align-items: center;
                "
              >
                <span class="material-icons" style="font-size: 20px">
                  {{ showPassword ? 'visibility_off' : 'visibility' }}
                </span>
              </button>
            </div>

            <!-- Password validation errors -->
            @if (
              resetForm.get('password')?.invalid &&
              resetForm.get('password')?.touched
            ) {
              <div
                style="margin-top: 0.5rem; font-size: 0.875rem; color: #ef4444"
              >
                @if (resetForm.get('password')?.hasError('required')) {
                  <!-- Message simple si champ vide -->
                  <p
                    style="
                      margin: 0;
                      display: flex;
                      align-items: center;
                      gap: 0.25rem;
                    "
                  >
                    <span class="material-icons" style="font-size: 16px"
                      >error</span
                    >
                    <span>Le mot de passe est obligatoire</span>
                  </p>
                } @else {
                  <!-- Liste des critères si mot de passe invalide -->
                  <p style="margin: 0 0 0.5rem 0; font-weight: 500">
                    Votre mot de passe doit contenir :
                  </p>
                  <ul style="margin: 0; padding-left: 1.5rem; list-style: none">
                    @for (error of getPasswordErrors(); track error) {
                      <li
                        style="
                          display: flex;
                          align-items: center;
                          gap: 0.25rem;
                          margin-bottom: 0.25rem;
                        "
                      >
                        <span class="material-icons" style="font-size: 16px"
                          >close</span
                        >
                        <span>{{ error }}</span>
                      </li>
                    }
                  </ul>
                }
              </div>
            }
          </div>

          <!-- Confirm password field -->
          <div class="form-group">
            <label for="confirmPassword">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                style="
                  width: 16px;
                  height: 16px;
                  display: inline-block;
                  margin-right: 6px;
                  vertical-align: middle;
                "
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
                ></path>
              </svg>
              Confirmation du mot de passe
            </label>
            <div class="input-container">
              <input
                [type]="showConfirmPassword ? 'text' : 'password'"
                id="confirmPassword"
                formControlName="confirmPassword"
                autocomplete="new-password"
                required
                placeholder="••••••••"
                class="text-black w-full !px-4 !py-3 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed"
              />
              <button
                type="button"
                (click)="toggleConfirmPasswordVisibility()"
                [attr.aria-label]="
                  showConfirmPassword
                    ? 'Masquer le mot de passe'
                    : 'Afficher le mot de passe'
                "
                style="
                  position: absolute;
                  right: 12px;
                  top: 50%;
                  transform: translateY(-50%);
                  background: none;
                  border: none;
                  cursor: pointer;
                  color: #6b7280;
                  padding: 4px;
                  display: flex;
                  align-items: center;
                "
              >
                <span class="material-icons" style="font-size: 20px">
                  {{ showConfirmPassword ? 'visibility_off' : 'visibility' }}
                </span>
              </button>
            </div>

            <!-- Password mismatch error -->
            @if (hasFormError('passwordMismatch')) {
              <p
                style="
                  margin-top: 0.5rem;
                  font-size: 0.875rem;
                  color: #ef4444;
                  display: flex;
                  align-items: center;
                  gap: 0.25rem;
                "
              >
                <span class="material-icons" style="font-size: 16px"
                  >error</span
                >
                <span>Les mots de passe ne correspondent pas</span>
              </p>
            }
          </div>

          <!-- Submit button -->
          <div class="form-group">
            <button
              type="submit"
              [disabled]="isButtonDisabled"
              class="w-full flex justify-center items-center gap-3 !py-3 !px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-vert-1 hover:bg-vert-2 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 cursor-pointer"
              [attr.aria-label]="statusLabel"
            >
              <span
                class="material-icons transition-transform duration-500"
                [class.animate-spin]="rotating"
                [innerHTML]="statusIcon"
              ></span>
              <span [innerHTML]="statusLabel"></span>
            </button>
          </div>
        </form>
      }
      <!-- Back to login -->
      <div class="form-links">
        <a class="reset-password" routerLink="/login">Retour à la connexion</a>
      </div>
    </div>
  </div>
</div>
